import { useRef, useEffect } from 'react';
import { useAppStore } from '../../store/useAppStore';

// Global refs (set by WebGLCapture via useFrame)
let glInstance: unknown = null;
const frameDeltas: number[] = [];

export const setWebGLInstance = (gl: unknown) => {
  glInstance = gl;
};

export const pushFrameDelta = (delta: number) => {
  frameDeltas.push(delta * 1000);
  if (frameDeltas.length > 30) frameDeltas.shift();
};

interface LabMonitorProps {
  thetaRef?: React.MutableRefObject<number>;
}

export const LabMonitor: React.FC<LabMonitorProps> = ({ thetaRef }) => {
  const divRef = useRef<HTMLDivElement>(null);

  // setInterval pour mise à jour DOM (pas de rAF dédié) ; FPS vient du frameloop R3F via pushFrameDelta
  useEffect(() => {
    const interval = setInterval(() => {
      const scrollVelocity = useAppStore.getState().velocity || 0;
      const scrollOffset = useAppStore.getState().scrollOffset || 0;
      const curvatureForce = 0.85;
      const thetaOffset = thetaRef?.current ?? scrollOffset * 2 * Math.PI;
      const drawCalls = (glInstance as { info?: { render?: { calls?: number } } })?.info?.render?.calls ?? 0;

      const avgDelta =
        frameDeltas.length > 0
          ? frameDeltas.reduce((a, b) => a + b, 0) / frameDeltas.length
          : 16;
      const fps = avgDelta > 0 ? Math.round(1000 / avgDelta) : 0;

      if (divRef.current) {
        divRef.current.innerText = `FPS: ${fps} | CALLS: ${drawCalls}\nVELOCITY: ${scrollVelocity.toFixed(3)} | CURVATURE: ${curvatureForce.toFixed(3)} | THETA: ${(thetaOffset % (2 * Math.PI)).toFixed(3)}`;
      }
    }, 250);

    return () => clearInterval(interval);
  }, [thetaRef]);

  return (
    <div className="fixed top-8 left-0 right-0 flex justify-center z-10 pointer-events-none">
      <div
        ref={divRef}
        className="text-black text-sm opacity-0 animate-fade-in whitespace-pre text-center"
        style={{ animationDelay: '500ms', animationFillMode: 'forwards' }}
      />
    </div>
  );
};
